import {deepCopy} from "./util";

/**
 * Reduces array of transactions
 * @param rows
 * @returns {*}
 */
export const mapReductionTransactions = (rows) => {
  return rows.map(item => {
    return {
      key: item.key,
      transactionId: item.transactionId,
      txnCode: item.txnCode,
      description: item.description,
      bookingDateTime: item.bookingDateTime,
      amount: item.amount,
      balanceAmount: item.balanceAmount,
    }
  })
}

/**
 * Compares string object of original data with new one
 * @param rows
 * @param originalData
 * @returns {boolean}
 */
export const isDataUnchanged = (rows, originalData) => {
  const updatedData = mapReductionTransactions(deepCopy(rows))
  return JSON.stringify(originalData) === JSON.stringify(updatedData)
}

/**
 * Calculate and validate all calculated Balances throughout the transactions array
 * @param data
 * @param sortASCDirection
 * @returns {*}
 */
export const initKeyAndCalculateValidateAmounts = (data, sortASCDirection, initialLoad = false) => {
  let dataCopy = sortASCDirection ? reverseArray(data) : deepCopy(data)

  if (initialLoad) {
    dataCopy = dataCopy.map((item, index) => {
      if (item.balanceAmount === null || item.balanceAmount === undefined)
        item.balanceAmountVsCalculatedBalanceError = true
      return item
    })
  }

  const newData = dataCopy.map((item, index) => {
    let calculatedBalance = null
    item.key = sortASCDirection ? dataCopy.length - index : item.key = index + 1

    if (!item.insertedRow) {
      if (index !== 0) {
        if (sortASCDirection) {
          if (
            ((dataCopy[index - 1].balanceAmount !== null) && (dataCopy[index - 1].balanceAmount !== undefined)) &&
            ((dataCopy[index].amount !== null) && (dataCopy[index].amount !== undefined))
          )
            calculatedBalance = parseFloat(dataCopy[index - 1].balanceAmount) + parseFloat(dataCopy[index].amount)
          else if (
            (index !== dataCopy.length - 1) &&
            ((dataCopy[index + 1].balanceAmount !== null) && (dataCopy[index + 1].balanceAmount !== undefined)) &&
            ((dataCopy[index + 1].amount !== null) && (dataCopy[index + 1].amount !== undefined))
          )
            calculatedBalance = parseFloat(dataCopy[index + 1].balanceAmount) - parseFloat(dataCopy[index + 1].amount)
          else
            calculatedBalance = item.calculatedBalance
        } else {
          if (
            ((dataCopy[index - 1].balanceAmount !== null) && (dataCopy[index - 1].balanceAmount !== undefined)) &&
            ((dataCopy[index - 1].amount !== null) && (dataCopy[index - 1].amount !== undefined))
          )
            calculatedBalance = parseFloat(dataCopy[index - 1].balanceAmount) - parseFloat(dataCopy[index - 1].amount)
          else if (
            (index !== dataCopy.length - 1) &&
            ((dataCopy[index + 1].balanceAmount !== null) && (dataCopy[index + 1].balanceAmount !== undefined)) &&
            ((dataCopy[index].amount !== null) && (dataCopy[index].amount !== undefined))
          )
            calculatedBalance = parseFloat(dataCopy[index + 1].balanceAmount) + parseFloat(dataCopy[index].amount)
          else
            calculatedBalance = item.calculatedBalance
        }
      } else {
        calculatedBalance = dataCopy[index].balanceAmount
      }
    }

    item.amount =
      ((item.amount !== null && item.amount !== undefined))
        ? parseFloat(item.amount).toFixed(2)
        : null
    item.balanceAmount =
      ((item.balanceAmount !== null && item.balanceAmount !== undefined))
        ? parseFloat(item.balanceAmount).toFixed(2)
        : null

    item.calculatedBalance =
      ((calculatedBalance !== null) && (calculatedBalance !== undefined))
        ? parseFloat(calculatedBalance).toFixed(2)
        : null

    item.insertedRow = !item.balanceAmountVsCalculatedBalanceError && (!item.amount || !item.balanceAmount)
    item.balanceAmountVsCalculatedBalanceError = !item.insertedRow && ((item.calculatedBalance !== item.balanceAmount) || !item.calculatedBalance)

    return item
  })
  return sortASCDirection ? reverseArray(newData) : newData
}

/**
 *
 * @param floatNumber
 * @returns {string|null}
 */
export const formatNumberToString = (floatNumber) => {
  const LOCALE = 'en-GB'
  return floatNumber
    ? new Intl.NumberFormat(LOCALE, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(floatNumber)
    : null
}

/**
 * Deep clone array and reverse it completely
 * @param array
 * @returns {*}
 */
export const reverseArray = (array) => {
  const copyArray = deepCopy(array)
  let left = null;
  let right = null;
  let length = copyArray.length;
  for (left = 0; left < length / 2; left += 1)
  {
    right = length - 1 - left;
    let temporary = copyArray[left];
    copyArray[left] = copyArray[right];
    copyArray[right] = temporary;
  }
  return copyArray;
}